import { Autocomplete, Button, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import { CSVLink } from "react-csv";
import Loader from "../../../../../components/loader/loader";

const OtWalletTransferReport = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const roleId = localStorage.getItem("role_id")
  const outletName = localStorage.getItem('outlet_name')
  const[cust, setCust] = useState(null)
  const outletId = localStorage.getItem('outlet_id')
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
    const [loading , setLoading] = useState(false)
  const [dateLimit, setDateLimit] = useState({
    // fromDate : roleId != 1 && roleId != 2 ? moment().format() : moment().startOf('month').format(),
    
    fromDate :  moment().startOf('month').format(),
    toDate : moment().format()
  })
  const fixedOutlet = { id: outletId, fullname: outletName };
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    maxWidth : 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date1",
    headerName: "Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "transfer_from",
    headerName: "Transfer From",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "transfer_to",
    headerName: "Transfer To",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "short_name",
    headerName: "Short Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 1,
    headerAlign: "center",
    align: "left",
    sortable: false,
  },
  {
    field: "transfer_amount",
    headerName: "Transfer Amount",
    flex: 1,
    headerAlign: "center",
    align: "right",
    sortable: false,
    hide: true, // This will hide the column
    renderCell: (params) => (
      <strong>{params.value}</strong>
  
  
    ),
    
  },
]

const rows = _.map(data,(val,idx)=>({
  // id: val.id,
  id: val.id || `row-${idx}`,
  sno: idx+1,
  date1 : moment(val.date).format('DD-MM-YYYY'),
  created_at: moment(val.created_at).format('DD-MM-YYYY'),
  updated_at: moment(val.updated_at).format('DD-MM-YYYY'),
  transfer_from: val.transfer_from,
  transfer_to: val.transfer_to,
  short_name:val.short_name || "-",
  description : val.description,
  transfer_amount : parseFloat(val.transfer_amount).toFixed(0),
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag,
  loading: loading
}
console.log(cust)
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.transfer_amount);
  });
  setTotalAmount(total.toFixed(0));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
function handlePaymentReport(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
    // docno : 0,
    outlet_id:cust!==null ? cust.id : fixedOutlet.id
  }
  console.log(postData)
  axios.post("/v1/outlet/wallet_transfer/report", postData)
  // axios.post(`/v1/reports/outletexpences/${cust!==null ? cust.id : fixedOutlet.id}`, postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    console.log(err)
    dispatch(setSnackbar(true, "error", "No Data Found"));
  })
}

function getSupplierData() {
  axios
    .get("/v1/outlet/list/1")
    .then((res) => {
      console.log(res.data)
      setSupplier(res.data);
      console.log( _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val)))
      _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))

    })
    .catch((err) => {
      dispatch(setSnackbar(true, "error", err.response.data.error));
    });
}
useEffect(() => {
  getSupplierData();
}, []);
  console.log(dateLimit)
  useEffect(()=>{
    if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handlePaymentReport()
    }
  },[rowsPerPage, page, dateLimit,cust])
  const generateCSVData = () => {
    const csvData = [
      ["Outlet Name", cust !== null ? cust.fullname : fixedOutlet.fullname],
      ["From Date", moment(dateLimit.fromDate).format('YYYY-MM-DD')],
      ["To Date", moment(dateLimit.toDate).format('YYYY-MM-DD')],
      [],
      ["S.no", "Date", "Bill No", "Account Name", "Remarks", "Amount"]
    ];
  
    rows.forEach(row => {
      csvData.push([
        row.sno,
        row.date1,
        row.docNo,
        row.accName,
        row.remarks,
        row.amount
      ]);
    });
  
    csvData.push([]);
  
    csvData.push(["", "", "", "", "Total Amount", totalAmount]);
  
    return csvData;
  };
  // const generateCSVData = () => {
  //   const csvData = [
  //     ["Outlet Name", cust !== null ? cust.fullname : fixedOutlet.fullname],
  //     ["From Date", moment(dateLimit.fromDate).format('YYYY-MM-DD')],
  //     ["To Date", moment(dateLimit.toDate).format('YYYY-MM-DD')],
  //     [],
  //     ["S.no", "Date", "Bill No", "Account Name", "Remarks", "Amount"],
  //     ["", "", "", " ", "Amount", totalAmount ]

  //   ];

  //   rows.forEach(row => {
  //     csvData.push([
  //       row.sno,
  //       row.date1,
  //       row.docNo,
  //       row.accName,
  //       row.remarks,
  //       row.amount
  //     ]);
  //   });

  //   return csvData;
  // };
  return (
    <Fragment>
      <Helmet><title>Outlet Wallet Transfer Reports</title></Helmet>
      <Typography variant="h6">Outlet Wallet Transfer Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
              size="small"
              value={cust}
              options={supplier}
              onChange={(e,value)=>setCust(value)}
              getOptionLabel={option=>option.fullname}
              disabled={(roleId != 1 && roleId != 2)} 
              renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              // disabled={roleId != 1 && roleId != 2} 
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              // disabled={roleId != 1 && roleId != 2} 
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        {/* <Grid item md={3} style={{ display: 'flex', alignItems: 'center' }}>
          <CSVLink data={generateCSVData()} filename={"outlet-expenses-report.csv"}>
            <Button variant="contained" color="primary">
              Download CSV
            </Button>
          </CSVLink>
        </Grid> */}
      </Grid>
      <CustomTable props={props} />
    </Fragment>
  );
};

export default memo(OtWalletTransferReport);